import React from 'react'
import { Card, Switch, Typography } from '@mui/material'
import { FixedSizeList } from 'react-window'

interface SymbolSwitchListProps {
  symbols: string[]
  enabledSwitches: string[]
  handleSwitch: (event: React.ChangeEvent<HTMLInputElement>, key: string) => void
}

const FRSymbolSwitchList: React.FC<SymbolSwitchListProps> = (props) => {
  const { symbols, enabledSwitches, handleSwitch } = props

  return (
    <FixedSizeList
      style={{
        width: '320px',
        height: `calc(100% - ${16 + 16}px)`,
        overflowY: 'scroll',
      }}
      width={320}
      height={830}
      itemData={symbols}
      itemSize={30}
      itemCount={symbols.length}
      overscanCount={5}
    >
      {
        ({ data, index, style }) => {
          const symbol = data[index]
          return (
            <Card
              key={symbol}
              variant='outlined'
              sx={{ minHeight: '30px', display: 'flex', gap: 1 }}
              style={style}
            >
              <Switch
                size='small'
                checked={enabledSwitches.includes(symbol)}
                onChange={(event) => {
                  handleSwitch(event, symbol)
                }}
              />
              <Typography>
                {symbol}
              </Typography>
            </Card>
          )
        }
      }
    </FixedSizeList>
  )
}

export default FRSymbolSwitchList
